/**
 * The collapsible panel's height.
 * @type {number}
 */
export const collapsiblePanelHeight = '--collapsible-panel-height';
/**
 * The collapsible panel's width.
 * @type {number}
 */
export const collapsiblePanelWidth = '--collapsible-panel-width';